/** @format */

export enum PersonalizedNumberRange {
  DOUBLE = '00,10-99',
  SINGLE_ALL = '1-9',
  SINGLE_LOW = '1-4',
}
